import store from 'src/js/store';
import actions from '../actions';

const hide = () => {
  store.dispatch(actions.hide());
};

export default hide;
